import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

const faqs: any = {
	"basic": {
		driving: [
			{
				question: "투어 참여에 나이 제한이 있나요?",
				answer: () => {
					return (
						<>
							<div>네, 국가별 차량 보험 등의 이유로 나이에 제한을 두고 있습니다.</div>
							<p>- 포르쉐/페라리/람보르기니 투어 : 운전자 만 27세 이상</p>
							<p>- BMW M 투어: 운전자 만 25세 이상 가능.</p>
						</>
					)
				}
			},
			{
				question: "1인 신청도 가능한가요?",
				answer: () => {
					return (
						<>
							<div>네 가능합니다. 1인 참여 시 전 일정 호텔과 차량을 혼자 이용하게 되며, 이에 따른 추가 비용이 발생됩니다.</div>
						</>
					)
				}
			},

			{
				question: "성인 3인이 신청할 경우 어떻게 되나요?",
				answer: () => {
					return (
						<>
							<div>- 3인 신청 시 호텔의 경우</div>
							<p>객실 2개 사용 – 싱글차지 발생(2인 1실 1개 + 1인 1실 1개)</p>
							<p>객실 1개 사용 – 3인실 혹은 2인실 + EXTRA BED 이용</p>
							<div className='mt-2'>- 3인 신청 시 차량의 경우</div>
							<p>차량 2대 사용 – 싱글차지 발생</p>
							<p>차량 1대 사용 – 파나메라/카이엔/마칸 중 배정</p>
							<p>*싱글차지 또는 소아를 포함한 3인 또는 4인의 경우 전화(02-564-9135) 또는 카카오톡 채널(@피피티 모터투어)로 문의 부탁드립니다.</p>
						</>
					)
				}
			},
		],
		riding: [
			{
				question: "투어 참여에 제한이 있나요?",
				answer: () => {
					return (
						<>
							<p>네 있습니다. 만 20세 이상 국가별 면허 통용문제 때문에 2종 소형 면허가 필히 있어야 합니다.</p>
						</>
					);
				},
			},
			{
				question: "2인 신청인데 텐덤도 가능한가요?",
				answer: () => {
					return (
						<>
							<p>네 가능합니다. 2인 텐덤 참여 시 전 일정 호텔과 렌탈을 같이 사용하게 되며,</p>
							<p>렌트비용은 1인 사용료만 내시면 됩니다.</p>
							<p>1인 투어 금액에서 바이크 렌트비만 빠진다고 보시면 됩니다.</p>
						</>
					);
				},
			},
			{
				question: "바이크를 직접 가져가는 경우 현지 운행이 가능한가요?",
				answer: () => {
					return (
						<>
							<p>네 가능합니다. 현지에서 사용하게 될 번호판과 영문등록증을 준비하셔야 합니다.</p>
							<p>임시 번호판은 서비스로 제작 해드립니다.</p>
						</>
					);
				},
			},
		],
	},
	"air": {
		driving: [
			{
				question: "항공권을 비즈니스로 변경하고 싶은데 가능한가요? 추가금이 얼마인가요?",
				answer: () => {
				  return (
					<>
					  <p>네 변경을 원하시는 시점에 비즈니스 좌석이 있을 경우 비즈니스로 변경이 가능합니다.</p>
					  <p>항공권의 금액은 예약하는 시점, 투어 일정에 따라 상이하므로, 비즈니스 클래스 업그레이드 시 발생되는 추가 운임에 대한 비용은 전화 또는 카카오톡 채널로 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "항공권을 개인적으로 따로 발권하고 싶은데 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 물론 가능합니다. 항공권이 포함된 투어에 참여하시는 회원님이 개별적으로 항공권 발권을 원하실 경우,</p>
					  <p>단체 항공권 금액을 투어 금액에서 공제하여 안내 드립니다.</p>
					  <p>따로 발권을 원하시는 경우, 예약 시 반드시 전화 또는 카카오톡 채널로 담당자에게 말씀주셔야 합니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "개인 마일리지로 항공권 발권이 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 물론 가능합니다. 투어 일정에 맞는 항공편으로 발권하시면 됩니다. 이 경우, 투어 금액에서 단체 항공권</p>
					  <p>운임을 제외해 드립니다. 개인적으로 항공권 발권을 원하시는 경우, 반드시 예약 시점에 저희 담당자에게</p>
					  <p>말씀 해주셔야 합니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "개인 마일리지로 항공권 업그레이드(일반석 – 비즈니스석)가 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>개인 마일리지로 항공권 업그레이드를 원하실 경우, 업그레이드가 가능한 클래스의 일반석 좌석을 예약하셔야 하므로,</p>
					  <p>유선 또는 카카오톡으로 담당자에게 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "투어 앞, 뒤로 일정을 추가할 수 있을까요? 몇일 더 남아서 여행하고 싶습니다.",
				answer: () => {
				  return (
					<>
					  <p>네 물론입니다. 항공권 발권 전이 예약 시점에 담당자에게 변경을 원하시는 일정을 말씀 주시면 투어 앞, 뒤로 일정 추가가 가능합니다.</p>
					  <p>이 또한 전화나, 카카오톡으로 담당자에게 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
		],
		riding: [
			{
				question: "항공권을 비즈니스로 변경하고 싶은데 가능한가요? 추가금이 얼마인가요?",
				answer: () => {
				  return (
					<>
					  <p>네 변경을 원하시는 시점에 비즈니스 좌석이 있을 경우 비즈니스로 변경이 가능합니다.</p>
					  <p>항공권의 금액은 예약하는 시점, 투어 일정에 따라 상이하므로, 비즈니스 클래스 업그레이드 시 발생되는 추가 운임에 대한 비용은 전화 또는 카카오톡 채널로 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "항공권을 개인적으로 따로 발권하고 싶은데 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 물론 가능합니다. 항공권이 포함된 투어에 참여하시는 회원님이 개별적으로 항공권 발권을 원하실 경우,</p>
					  <p>단체 항공권 금액을 투어 금액에서 공제하여 안내 드립니다.</p>
					  <p>따로 발권을 원하시는 경우, 예약 시 반드시 전화 또는 카카오톡 채널로 담당자에게 말씀주셔야 합니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "개인 마일리지로 항공권 발권이 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 물론 가능합니다. 투어 일정에 맞는 항공편으로 발권하시면 됩니다. 이 경우, 투어 금액에서 단체 항공권</p>
					  <p>운임을 제외해 드립니다. 개인적으로 항공권 발권을 원하시는 경우, 반드시 예약 시점에 저희 담당자에게</p>
					  <p>말씀 해주셔야 합니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "개인 마일리지로 항공권 업그레이드(일반석 – 비즈니스석)가 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>개인 마일리지로 항공권 업그레이드를 원하실 경우, 업그레이드가 가능한 클래스의 일반석 좌석을 예약하셔야 하므로,</p>
					  <p>유선 또는 카카오톡으로 담당자에게 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "투어 앞, 뒤로 일정을 추가할 수 있을까요? 몇일 더 남아서 여행하고 싶습니다.",
				answer: () => {
				  return (
					<>
					  <p>네 물론입니다. 항공권 발권 전이 예약 시점에 담당자에게 변경을 원하시는 일정을 말씀 주시면 투어 앞, 뒤로 일정 추가가 가능합니다.</p>
					  <p>이 또한 전화나, 카카오톡으로 담당자에게 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
		],
	},
	"payment": {
		driving: [
			{
				question: "계약금은 취소 및 환불이 되나요?",
				answer: () => {
				  return (
					<>
					  <p>계약금은 결제 후 취소 및 환불이 불가하며, 각 투어의 하단에 기재된 [공정거래위원회] 10021호 외 특약적용에 따른 환불 규정을 읽어 봐주시기 바랍니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "투어잔금은 언제 결제 할 수 있나요?",
				answer: () => {
				  return (
					<>
					  <p>투어 잔금은 계약금과 동시에 결제도 가능하며, 투어 출발 45일 전까지 완납해주시면 됩니다.</p>
					  <p>잔금 결제 마감일은 참가하시는 회원님께 개별적으로 안내 드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "잔금 결제를 마감일까지 못하면 어떻게 되나요?",
				answer: () => {
				  return (
					<>
					  <p>잔금 결제를 못하실 경우 신청하신 투어에서 자동취소되며, 계약금은 환불이 되지 않습니다.</p>
					</>
				  );
				},
			  },
		],
		riding: [
			{
				question: "계약금은 취소 및 환불이 되나요?",
				answer: () => {
				  return (
					<>
					  <p>계약금은 결제 후 취소 및 환불이 불가하며, 각 투어의 하단에 기재된 [공정거래위원회] 10021호 외 특약적용에 따른 환불 규정을 읽어 봐주시기 바랍니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "투어잔금은 언제 결제 할 수 있나요?",
				answer: () => {
				  return (
					<>
					  <p>투어 잔금은 계약금과 동시에 결제도 가능하며, 투어 출발 45일 전까지 완납해주시면 됩니다.</p>
					  <p>잔금 결제 마감일은 참가하시는 회원님께 개별적으로 안내 드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "잔금 결제를 마감일까지 못하면 어떻게 되나요?",
				answer: () => {
				  return (
					<>
					  <p>잔금 결제를 못하실 경우 신청하신 투어에서 자동취소되며, 계약금은 환불이 되지 않습니다.</p>
					</>
				  );
				},
			  },
		],
	},
	"tour": {
		driving: [
			{
				question: "객실 이용 및 차량 운전을 혼자 하고 싶은데 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 전 일정 객실과 차량 모두 단독 이용 가능합니다. 싱글 차지가 발생됩니다.</p>
					  <p>싱글차지는 투어 별, 일자 별 상이하므로, 전화 또는 카카오톡 채널로 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "추가적으로 현지에서 지불 해야하는 금액이 있나요?",
				answer: () => {
				  return (
					<>
					  <p>투어의 비용에는 점심식사를 제외한 조·석식 호텔, 주차 비용 등의 거의 모든 비용이 포함되어 있습니다.</p>
					  <p>현지에서 톨비(TOLL FEE), 주유, 개인 쇼핑 및 간식 비용 정도의 작은 비용만 추가적으로 필요할 수 있습니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "포르쉐는 911만 가능한가요? 파나메라, 카이엔, 마칸, 박스터 등 다른 모델도 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>일반적으로 포르쉐 투어의 경우 포르쉐 911을 포함하고 있으나 파나메라, 카이엔, 마칸 등의 다양한 포르쉐 차량도 준비가 가능합니다.</p>
					  <p>911을 제외한 나머지 차량의 경우 사전 예약을 통하여, 준비해드리고 있습니다.</p>
					  <p>사전 예약을 원하실 경우 유선 또는 카카오톡으로 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "투어에 사용하는 포르쉐 차량을 혼자 운전하나요?",
				answer: () => {
				  return (
					<>
					  <p>모든 투어는 2인 1조로 팀을 이루어 2인이 1대의 차량을 운행하게 됩니다.</p>
					  <p>배정받은 한 차량을 두분이 번갈아 탑승이 가능합니다. 배정받지 않은 타 차량의 탑승은 특수한 경우를 제외하고는 보험 적용 등의 사유로 불가합니다.</p>
					  <p>* 단 업그레이드 투어의 경우, 모든 회원님이 전체 차량을 번갈아가며, 탑승이 가능합니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "세부 일정 및 준비 사항은 언제 안내를 받나요?",
				answer: () => {
				  return (
					<>
					  <p>투어에 참가하시는 회원님들께 담당자가 세부 일정 및 준비사항을 개별적으로 안내 드리고 있습니다.</p>
					  <p>일반적으로 잔금 결제 후 안내 드리고 있습니다.</p>
					</>
				  );
				},
			  },
		],
		riding: [
			{
				question: "객실 이용 및 바이크 운전을 혼자 하고 싶은데 가능한가요?",
				answer: () => {
				  return (
					<>
					  <p>네 전 일정 바이크는 모두 단독 이용 가능하시나, 객실은 싱글 차지가 발생됩니다.</p>
					  <p>싱글차지는 투어 별, 일자 별 상이하므로, 전화 또는 카카오톡 채널로 문의 부탁드립니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "추가적으로 현지에서 지불해야 하는 금액이 있나요?",
				answer: () => {
				  return (
					<>
					  <p>투어 비용에는 투어에 따라 다르지만 선박 혹은 항공, 조·석식 호텔, 비용 등 거의 모든 비용이 포함되어 있습니다.</p>
					  <p>현지에서 톨비(TOLL FEE), 주유, 개인 쇼핑 및 간식 비용 정도의 작은 비용만 추가적으로 필요할 수 있습니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "바이크의 렌트 기준은 마음대로 고를 수 있나요?",
				answer: () => {
				  return (
					<>
					  <p>일반적으로 국가별 렌트가 가능한 라인업을 상품정보란에 표기해드립니다.</p>
					  <p>베트남, 일본의 경우 P3200CC~500CC 이하의 보편적인 렌트비용에 포함되어 있으나 그 이상의 CC를 원하는 경우 별도의 비용이 발생됩니다.</p>
					  <p>그 외의 국가별 상황에 따라 가능한 기종이 상이하기 때문에 담당자에게 문의 부탁드리겠습니다.</p>
					</>
				  );
				},
			  },
			  {
				question: "세부 일정 및 준비 사항은 언제 안내를 받나요?",
				answer: () => {
				  return (
					<>
					  <p>투어에 참가하시는 회원님들께 담당자가 세부 일정 및 준비사항을 개별적으로 안내 드리고 있습니다.</p>
					  <p>일반적으로 잔금 결제 후 안내 드리고 있습니다.</p>
					</>
				  );
				},
			  },
		],
	}
}


export default function FAQ({
	productType
}: any) {

	let [type, setType] = useState<any>("basic");

	return (
		<div id="information" className={`listingSection__wrap space-y-0 p-0`}>
			<div className="flex justify-between pl-5 pt-5 pr-5 pb-5">
				<h2 className="text-lg sm:text-2xl  font-semibold font-snas-kr">
					FAQ
				</h2>
				<div>

				</div>
			</div>

			<div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

			<div className="text-neutral-6000 dark:text-neutral-300 bg-white rounded-b-2xl">

				<div className="w-full px-4">

					<div className="flex space-x-4 mb-6 mt-4">
						<button
							onClick={() => setType("basic")}
							className={`px-4 py-2 rounded-lg ${type === "basic"
									? "bg-red-500 text-white"
									: "bg-gray-200 text-gray-700 hover:bg-gray-300"
								}`}
						>
							참가기준
						</button>
						<button
							onClick={() => setType("air")}
							className={`px-4 py-2 rounded-lg ${type === "air"
									? "bg-red-500 text-white"
									: "bg-gray-200 text-gray-700 hover:bg-gray-300"
								}`}
						>
							항공
						</button>
						<button
							onClick={() => setType("payment")}
							className={`px-4 py-2 rounded-lg ${type === "payment"
									? "bg-red-500 text-white"
									: "bg-gray-200 text-gray-700 hover:bg-gray-300"
								}`}
						>
							결제
						</button>
						<button
							onClick={() => setType("tour")}
							className={`px-4 py-2 rounded-lg ${type === "tour"
									? "bg-red-500 text-white"
									: "bg-gray-200 text-gray-700 hover:bg-gray-300"
								}`}
						>
							투어
						</button>
					</div>

					<div className="mx-auto w-full rounded-2xl bg-white p-1 pb-5">
						{faqs[type][productType].map((item: any, index: number) => (
							<Disclosure key={index} as="div" className="mt-2">
								{({ open }) => (
									<>
										<Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
											<span>{item.question}</span>
											<ChevronUpIcon
												className={`${open ? 'rotate-180 transform' : ''
													} h-5 w-5 text-purple-500`}
											/>
										</Disclosure.Button>
										<Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
											{item.answer()}
										</Disclosure.Panel>
									</>
								)}
							</Disclosure>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}